export default __webpack_public_path__ + "static/163-40c4c646cdc8112ff6b747780f0c38ea.jpg";